module.exports = __webpack_public_path__ + "static/Clint-7af330cd90e40f5539ea73c96975e735.jpg";